import React, { Component } from "react";
import DialogHeaderViewStyle from "./DialogHeaderViewStyle";
import DialogHeaderViewProps from "./DialogHeaderViewProps";
import TranslationView from "../../../../../../components/Translation/TranslationView";

export default class DialogHeaderView extends Component<DialogHeaderViewProps> {

    private _style = new DialogHeaderViewStyle();

    render() {
        return (
            <div style={this._style.header}>
                <div style={this._style.headerTextContainer}>
                    <TranslationView style={this._style.title}>
                        {this.props.title}
                    </TranslationView>
                    
                    <TranslationView style={this._style.subtitle}>
                        {this.props.subtitle}
                    </TranslationView>
                </div>
                <img style={this._style.smallLogo} src={require('../../../../../../assets/small_logo.png')} alt="The Medicheck logo" />
            </div>
        );
    }
}